
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"17.679","cy":"18.768","r":"2.234","fill":"#890491"}}),_c('path',{attrs:{"d":"M13.046.046a11.958 11.958 0 00-8.482 2.541 7.373 7.373 0 11-.543.455 12 12 0 109.025-3zM17.4 21.92a3.165 3.165 0 113.428-2.877A3.165 3.165 0 0117.4 21.92z","fill":"#890491"}})])
          )
        }
      }
    